export { default, articleSplits } from './StandardArticleLayout';
